import React from 'react';

function Pin({ color = '#335B70', ...props }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.251 20.088c.874-1.235 1.53-2.95 3.525-6.147-1.22-1.213-1.926-1.91-2.81-2.795C2.313 8.19 8.99 8.37 10.986 8.854l3.064-3.064c-.738-2.04.045-4.325 1.649-3.647l6.302 6.303c.796 1.603-1.607 2.386-3.646 1.649l-3.064 3.063c.515 2.05.714 8.679-2.293 7.022-.884-.884-1.592-1.585-2.805-2.805-3.247 1.984-4.865 2.681-6.1 3.556-.574.408-1.241-.305-.843-.843z"
                fill={color}
            />
        </svg>
    );
}

export default Pin;
